import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Clients from './pages/Clients';
import Tasks from './pages/tasks';

export default function App() {
  return (
    <Router>
      <div style={styles.container}>
        <nav style={styles.nav}>
          <Link to="/clients" style={styles.link}>לקוחות</Link>
          <Link to="/tasks" style={styles.link}>משימות</Link>
        </nav>
        <main style={styles.main}>
          <Routes>
            <Route path="/clients" element={<Clients />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="*" element={<div>בחר תפריט למעלה</div>} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: '#e6f0ff',
    minHeight: '100vh',
  },
  nav: {
    backgroundColor: '#0052cc',
    padding: '10px',
    display: 'flex',
    gap: '20px',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    fontWeight: 'bold' as 'bold',
  },
  main: {
    padding: '20px',
    color: '#003366',
  },
};
